import { useCallback, useEffect, useState } from "react";
import { fetchClubs } from "./api";
import type { Club } from "./types";

interface UseClubsResult {
  clubs: Club[];
  loading: boolean;
  error: string | null;
  setError: (message: string | null) => void;
  refetch: (options?: { silent?: boolean }) => Promise<void>;
}

export const useClubs = (): UseClubsResult => {
  const [clubs, setClubs] = useState<Club[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async (options?: { silent?: boolean }) => {
    const silent = options?.silent === true;
    try {
      if (!silent) setLoading(true);
      setError(null);
      const data = await fetchClubs();
      setClubs(data);
    } catch (err) {
      console.error("Error fetching clubs:", err);
      setError("Failed to load clubs. Please try again later.");
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { clubs, loading, error, setError, refetch };
};
